import { readConsentFromBrowser } from './document-cookie';
import { hasAnalyticsConsent } from './has-analytics-consent';

/** True when running in the browser and jc_consent_v1 allows analytics. */
export function isClientAnalyticsAllowed(): boolean {
  if (typeof window === 'undefined') return false;
  return hasAnalyticsConsent(readConsentFromBrowser());
}
